<template>
	<div class="mhuaiContainer">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<img class="mFirst"
				src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-34-00_35864.jpeg">
		</div>
		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- 	<el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>

		<img class="mSecond"
			src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-54-13_46903.jpg" alt="">
		<img class="mSecond"
			src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-54-41_28965.jpg" alt="">
		<img class="mSecond"
			src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-55-07_7244.jpg" alt="">
		<img class="mSecond"
			src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_14-00-33_95777.jpg" alt="">
		<!-- <div class="mThirdItem">
			<img class="mThird" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-25-08_27744.jpg" alt="">
		</div>
		<div class="mForthItem">
			<img class="mThird" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-30-12_18628.jpg" alt="">
		</div>
		<div class="mFifthItem">
				<img class="mFifth" src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-12-08_11-37-22_36862.jpg" alt="">
		</div> -->
		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			drawer: false,
			direction: 'ltr'
		}
	},
	methods: {
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		},
		enterProducts(id) {
			this.$router.push({ path: '/mProductList', query: { brandId: id } });
		},
	}
}
</script>

<style scoped>
.mhuaiContainer {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 15%;
	z-index: 99;
}

.mFirstBoxMenu {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
}

.mFirstBoxImgMenu {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.mFirstBoxImgBox {
	width: 100%;
}


.mFirstBoxImg {
	width: 40%;
	float: right;
	margin-right: 20%;
}

.firstBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}

.mSecond {
	width: 100%;
}

.mThird {
	width: 100%;
	position: absolute;
}


.mFirstImg {
	float: right;
	width: 30%;
	margin-right: 6rem;
	position: relative;
	top: -2.5rem;
}

.mFirstImgItem {
	margin-top: -8.5rem;
}

.mThirdItem {
	width: 100%;
	background: url(../../assets/huaiBdNew3.jpg) no-repeat;
	background-size: 100%;
}



.pageTopTitle {
	font-size: 1.4rem;
	font-family: SimSun;
	font-weight: bold;
	color: #222222;
	line-height: 15px;
	text-align: center;
}


.pageBoxMainBody3 {
	width: 95%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	padding-top: 7%;
	padding-bottom: 7%;
}

.pageRowNew {
	width: 90%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	margin-top: 1.5rem;
}

.busiz-text-ellipes1 {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}

.itemBox1 {
	display: flex;
	flex-direction: column;
	opacity: 1;
	width: 100%;
}


.itemBoxTitle1 {
	font-size: 0.9rem;
	color: #111111;
	font-weight: 400;
	line-height: 25px;
	margin-top: 0.5rem;
	text-align: center;
	min-width: 60px;
}

.itemBoxImg {
	width: 100%;
}

.itemBoxImg1 {
	width: 100%;
}


.itemBoxImg2 {
	width: 100%;
}

.addImg {
	width: 100%;
}

.addBox {
	width: 10%;
	margin-left: 1rem;
	margin-right: 1rem;
}

/* .addBox{
	 	margin-left:0;
	  } */

/* .itemBox2{
	 	margin-left:9%;
	  }

	  .itemBox3{
	 	margin-left: 7%;
	  } */

.pageBoxMainBodyBottom {
	font-size: 1.1rem;
	font-weight: 400;
	color: #111111;
	line-height: 25px;
	width: 50%;
	margin: 0 auto;
	text-align: center;
	position: relative;
	top: 40%;
	opacity: 0.5;
	-moz-transition: 1.5s;
	-webkit-transition: 1.5s;
}

.mForthItem {
	width: 100%;
	/* display: flex;
		flex-direction:column;
		align-items: center; */
	background-color: #103A26;
}

.pageBoxMain4 {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.mForthItemMiddle {
	width: 90%;
	display: flex;
	margin: 0 auto;
	flex-direction: row;
	align-items: center;
	margin-top: 4rem;
	margin-bottom: 4rem;
}

.mForthItemMiddleLeft {
	width: 48%;
}

.linianImg {
	width: 100%;
}

.mForthItemMiddleRight {
	width: 50%;
	display: flex;
	flex-direction: column;
	margin-left: 0.5rem;
}

.titleT {
	color: #FFFFFF;
	font-size: 1.4rem;
}

.textT {
	color: #FFFFFF;
	font-size: 0.9rem;
	opacity: 0.8;
	margin-top: 0.3rem;
}



.mFifthItem {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: url(../../assets/mImg/huaiNewBu.png) no-repeat;
	background-size: 100%;
	/* padding-top: 2rem; */
}

.mFifth {
	width: 100%;
}

.mFifthItemMiddle {
	width: 70%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 5%;
	padding-bottom: 5%;
}

.mFifthItemMiddleImg {
	width: 100%;
	border-radius: 1rem;
}


.mFifthItemMiddleImgItem {
	width: 100%;
	border-radius: 1rem;
}

.mFifthItemMiddleT1 {
	color: #111111;
	font-size: 1.4rem;
	margin-top: 1rem;
}

.mFifthItemMiddleT2 {
	color: #333333;
	font-size: 0.9rem;
	text-align: center;
	margin-top: 0.5rem;
}





.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #FFFFFF;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	color: #FFFFFF;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	color: #FFFFFF;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}



.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	color: #FFFFFF;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #FFFFFF;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}



.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color: #620c0b;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

.pageTitleBox {
	width: 95%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
}

.titleBox {
	width: 33.3%;
	font-size: 0.9rem;
	color: #111111;
	font-weight: 400;
	line-height: 25px;
	text-align: center;
}


/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	z-index: 999;
	justify-content: space-between;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mlanshuBrand.vue